/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  /* eslint-disable */

  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();
          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      // Use event delegation for better performance
      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);
        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").data("line-item");
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);
        return false;
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();
        return false;
      });

      // Escape must dismiss the drawer (WCAG 2.1.2 / 1.4.13).
      $(document).on("keydown", function (e) {
        if (e.key !== "Escape" && e.key !== "Esc") return;
        var cart = window.PXUTheme.jsAjaxCart;
        if (!cart.ajaxCartDrawer || !cart.ajaxCartDrawer.hasClass("is-visible")) return;
        cart.hideDrawer();
      });

      // Keep Tab / Shift+Tab inside the open drawer (WCAG 2.4.3).
      $(document).on("keydown", function (e) {
        if (e.key !== "Tab") return;
        var cart = window.PXUTheme.jsAjaxCart;
        if (!cart.ajaxCartDrawer || !cart.ajaxCartDrawer.hasClass("is-visible")) return;

        // Same pick as showDrawer(): the drawer that is actually rendered.
        var drawer = null;
        cart.ajaxCartDrawer.each(function () {
          if (!drawer && this.getClientRects().length > 0) drawer = this;
        });
        if (!drawer) return;

        var focusable = Array.prototype.filter.call(
          drawer.querySelectorAll(
            "a[href], button, input, select, textarea, [tabindex]:not([tabindex='-1'])"
          ),
          function (el) {
            return (
              !el.disabled &&
              el.tabIndex >= 0 &&
              el.getClientRects().length > 0 &&
              window.getComputedStyle(el).visibility !== "hidden"
            );
          }
        );
        if (!focusable.length) {
          e.preventDefault();
          drawer.focus();
          return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;

        if (!drawer.contains(active) || active === drawer) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && active === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      });
    },

    // Polite live-region announcement for cart updates (WCAG 4.1.3).
    announceCartUpdate: function (itemCount) {
      var $status = $("[data-ajax-cart-status]");
      if (!$status.length) return;
      var template = $status.first().attr("data-message") || "";
      if (!template) return;
      var message = template.replace("__COUNT__", itemCount);
      // Clear first so an identical message is announced again.
      $status.text("");
      window.setTimeout(function () {
        $status.text(message);
      }, 100);
    },

    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
        function () {
          if (
            window.PXUTheme.theme_settings.header_layout == "centered" &&
            $(".header-sticky-wrapper").hasClass("is-sticky")
          ) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
              "show-mini-cart"
            );
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },

    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
        "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },

    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },

    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      // Remember where focus came from so close can restore it.
      this.lastFocusedBeforeDrawer = document.activeElement;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");

      // Both the desktop and mobile headers render a drawer; the one for the
      // other breakpoint sits in a display:none container, where focus() is a
      // silent no-op. getClientRects() is empty only for display:none, so it
      // picks the rendered drawer without being fooled by position:fixed.
      var drawer = null;
      this.ajaxCartDrawer.each(function () {
        if (!drawer && this.getClientRects().length > 0) drawer = this;
      });
      if (!drawer) drawer = this.ajaxCartDrawer[0];

      if (drawer) {
        // Scroll-reveal animations leave some drawer links visibility:hidden,
        // and those cannot take focus — skip to the first genuinely visible one.
        var candidates = drawer.querySelectorAll(
          "a[href], button, input, select, textarea, [tabindex]:not([tabindex='-1'])"
        );
        var first = null;
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          if (
            !el.disabled &&
            el.getClientRects().length > 0 &&
            window.getComputedStyle(el).visibility !== "hidden"
          ) {
            first = el;
            break;
          }
        }
        var moveFocus = function () {
          if (first) {
            first.focus();
          } else {
            drawer.setAttribute("tabindex", "-1");
            drawer.focus();
          }
        };
        // Deferred so the click that opened the drawer cannot refocus its own
        // trigger afterwards.
        window.requestAnimationFrame(moveFocus);
      }
    },

    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      var wasOpen = this.ajaxCartDrawer.hasClass("is-visible");
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");

      if (!wasOpen) return;
      // The closed drawer is visibility:hidden, so focus left inside it would
      // drop to <body> and the next Tab would resume past the header.
      var active = document.activeElement;
      var inside = active && active.closest && active.closest("[data-ajax-cart-drawer]");
      if (!active || active === document.body || inside) {
        var target = this.lastFocusedBeforeDrawer;
        if (!target || !document.contains(target)) {
          target =
            document.querySelector("[data-ajax-cart-trigger]") ||
            document.querySelector('.header__link[href="/cart"]');
        }
        if (target) target.focus();
      }
    },

    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();

          // Update cart page if jsCart exists, using promise-based approach
          if (window.PXUTheme.jsCart) {
            window.PXUTheme.jsCart.removeFromCart(lineID);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          console.error("Error removing item from cart:", response);
        },
      });
    },

    // Cache for cart data to avoid redundant requests
    cartCache: null,
    cartCacheTime: 0,
    cartCacheExpiry: 5000, // 5 seconds - increased to reduce redundant requests
    isUpdating: false, // Prevent concurrent add-to-cart requests

    // Load cart data either from cache or from server
    loadCartData: function () {
      const currentTime = Date.now();

      // If we have a recent cache, use it
      if (
        this.cartCache &&
        currentTime - this.cartCacheTime < this.cartCacheExpiry
      ) {
        return Promise.resolve(this.cartCache);
      }

      // Otherwise, fetch fresh data
      return window.PXUTheme.asyncView
        .load(window.PXUTheme.routes.cart_url, "ajax")
        .then((result) => {
          this.cartCache = result;
          this.cartCacheTime = currentTime;
          return result;
        });
    },

    initializeAjaxCart: function () {
      this.loadCartData()
        .then(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          // Converting the currencies
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        })
        .catch((error) => {
          console.error("Error initializing cart:", error);
        });
    },

    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      this.loadCartData()
        .then(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);
        })
        .catch((error) => {
          console.error("Error initializing mobile cart:", error);
        });
    },

    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
      this.recipientForm = $addToCartForm[0].querySelector(
        "[data-recipient-form]"
      );

      if (this.recipientForm) {
        this.recipientForm.classList.remove("recipient-form--has-errors");
      }

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;
        $(".warning").remove();

        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
          .find("span:not(.icon)")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
      } else {
        // Prevent concurrent add-to-cart requests
        if (this.isUpdating) {
          return;
        }
        this.isUpdating = true;

        // Start showing loading state immediately
        $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
        $addToCartBtn.find(".nice-frame").text("Adding item...");

        // Add to cart AJAX request
        $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          type: "post",
          data: $addToCartForm.serialize(),
          success: (product) => {
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            const addedToCart = () => {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");
              $addToCartBtn.find("span").removeClass("fadeInDown");
            };

            // Update cart view immediately (don't wait for animation)
            this.updateView()
              .then(() => {
                // Clear cart cache AFTER successful add to ensure fresh data next time
                this.cartCache = null;
                this.isUpdating = false;
              })
              .catch(() => {
                this.isUpdating = false;
              });
            
            // Safety timeout: ensure isUpdating is reset even if updateView() hangs
            // This prevents the button from being permanently disabled
            setTimeout(() => {
              if (this.isUpdating) {
                console.warn("updateView() took longer than expected, resetting isUpdating flag");
                this.isUpdating = false;
              }
            }, 10000); // 10 second safety timeout

            // Animation handling - non-blocking
            window.setTimeout(() => {
              // Always reset isUpdating flag when re-enabling button
              // This ensures button works even if updateView() hangs
              this.isUpdating = false;
              
              $addToCartBtn.removeAttr("disabled").removeClass("disabled");

              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

              $addToCartBtn
                .find(".text, .icon")
                .removeClass("zoomOut")
                .addClass("fadeInDown");

              $addToCartBtn.one(
                "webkitAnimationEnd oanimationend msAnimationEnd animationend",
                addedToCart
              );

              // Show drawer immediately after cart update completes
              this.showDrawer();
            }, 800); // Reduced from 1000ms to 800ms

            // Update cart page ONLY if user is on cart page (non-blocking)
            if (
              window.PXUTheme.jsCart &&
              window.location.pathname === "/cart"
            ) {
              // Debounce cart page updates
              clearTimeout(this.cartPageUpdateTimeout);
              this.cartPageUpdateTimeout = setTimeout(() => {
                $.ajax({
                  dataType: "html",
                  url: "/cart",
                  success: function (html) {
                    const cartForm = $(html).find(".cart__form");
                    if (cartForm.length) {
                      $(".cart__form").replaceWith(cartForm);
                    }
                  },
                });
              }, 300);
            }

            $addToCartBtn.find(".nice-frame").text("Add to cart");
          },
          error: (XMLHttpRequest) => {
            this.isUpdating = false;
            const response = eval("(" + XMLHttpRequest.responseText + ")");
            $(".warning").remove();

            let cartWarning;
            if (response.errors && response.errors.email) {
              this.recipientForm.classList.add("recipient-form--has-errors");
            } else {
              cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace("All 1 ", "All ")}</p>`;
              $addToCartForm.find(".cart-warning").html(cartWarning);
            }

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
              .find(".icon")
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn
              .find("span:not(.icon)")
              .text($addToCartBtn.data("label"))
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn.find(".nice-frame").text("Add to cart");
          },
        });
      }
    },

    updateView: function () {
      return this.loadCartData()
        .then(({ html, options }) => {
          if (options.item_count > 0) {
            // Batch DOM updates for better performance
            const $content = $(html.content);
            const itemList = $content.find(".ajax-cart__list");
            const cartDetails = $content.find(".ajax-cart__details-wrapper");

            // Use document fragments for better performance
            const fragment = document.createDocumentFragment();
            fragment.appendChild(itemList[0]);

            $(".ajax-cart__list").replaceWith(itemList);
            $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
            $(".ajax-cart__empty-cart-message").addClass("is-hidden");
            $(".ajax-cart__form").removeClass("is-hidden");
            $("[data-ajax-cart-trigger]").addClass("has-cart-count");
            $('[data-bind="itemCount"]').text(options.item_count);
          } else {
            $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
            $(".ajax-cart__form").addClass("is-hidden");
            $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
            $('[data-bind="itemCount"]').text("0");
          }

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }

          this.announceCartUpdate(options.item_count);

          return { html, options };
        })
        .catch((error) => {
          console.error("Error updating cart view:", error);
        });
    },

    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  /******/
})();
